import { render, staticRenderFns } from "./user-tree.vue?vue&type=template&id=43064343"
import script from "./user-tree.vue?vue&type=script&lang=js"
export * from "./user-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports